<script setup lang="ts">
import { capitalize } from 'vue'

const loginUrl = import.meta.env.VITE_LOGIN_URL

const { variant = 'regular' } = defineProps<{ variant?: 'regular' | 'compact' }>()

const onLoginClick = (event: Event) => {
  if (import.meta.env.PROD) return

  event.preventDefault()
  localStorage.setItem('dev_access_token', import.meta.env.VITE_DEV_ACCESS_TOKEN || '')
}
</script>

<template>
  <div :class="[$style.root, $style['rootVariant' + capitalize(variant)]]">
    You must be logged in to send a message

    <a :class="[$style.login, $style['loginVariant' + capitalize(variant)]]" :href="loginUrl" @click="onLoginClick">
      Log in
    </a>
  </div>
</template>

<style lang="scss" module>
@use '#mixins/button' as button;
@use '#mixins/media' as media;
@use '../mixins.scss' as *;

.root {
  @include message-editor-padding;
  height: $messageEditorHeight;
  display: flex;
  align-items: center;
  gap: 32px;
  justify-content: space-between;

  @include media.mobile {
    height: $messageEditorHeightMobile;
    @include message-editor-padding-mobile;
  }
}

.rootVariantCompact {
  @include message-editor-padding-comact;
  height: $messageEditorHeightCompact;
  font-size: 14px;

  @include media.mobile {
    @include message-editor-padding-comact;
    height: $messageEditorHeightMobile;
  }
}

.login {
  @include button.primary;
  display: flex !important;
  white-space: nowrap;

  @include media.mobile {
    font-size: 14px;
    padding-left: 10px;
    padding-right: 10px;
    height: 32px;
  }
}

.loginVariantCompact {
  font-size: 14px;
  padding-left: 10px;
  padding-right: 10px;
  height: 32px;
  width: auto !important;
}
</style>
